class AgStickyBar extends HTMLElement {
  connectedCallback() {
    this.updateFooterSpacing();

    this.handleViewportResize = () => this.updateFooterSpacing();
    window.addEventListener('resize', this.handleViewportResize, { passive: true });

    if ('ResizeObserver' in window) {
      this.barResizeObserver = new ResizeObserver(() => this.updateFooterSpacing());
      this.barResizeObserver.observe(this);
    }

    requestAnimationFrame(() => this.updateFooterSpacing());
  }

  disconnectedCallback() {
    this.barResizeObserver?.disconnect();
    window.removeEventListener('resize', this.handleViewportResize);
  }

  updateFooterSpacing() {
    const barHeight = Math.ceil(this.getBoundingClientRect().height);

    if (barHeight <= 0) {
      return;
    }

    // Sticky bar-এর rendered height অনুযায়ী footer-এর নিচে safe space তৈরি হবে।
    document.documentElement.style.setProperty(
      '--ag-sticky-bar-height',
      `${barHeight}px`
    );
  }
}

if (!customElements.get('ag-sticky-bar')) {
  customElements.define('ag-sticky-bar', AgStickyBar);
}
